import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import { styles as containerStyles } from '../styles/container';
import Title from './Title';
import { CONTACT } from '../routing';
import { Paper } from '@material-ui/core';

import IrakakairouImage from '../../../images/features/ana/irakakairou.jpg';
import ShimaneImage from '../../../images/features/ana/shimane.png';
import YutalabImage from '../../../images/features/ana/yutalab.jpg';
import MasudaImage from '../../../images/features/ana/masuda.jpg';
import TottoriPrefectureImage from '../../../images/features/ana/tottori_prefecture.png';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: theme.breakpoints.values.lg,
    margin: 'auto',
    ...containerStyles(theme),
  },
  paper: {
    border: `solid thin #FD591F`,
  },
  paperInner: {
    width: '100%',
    margin: 0,
    '& > *': {
      padding: theme.spacing(3, 2),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(5, 4),
      },
    },
  },
  containerLogos: {
    margin: '2em 0',
    width: '100%',
    '& > *': {
      textAlign: 'center',
    },
  },
  logo: {
    width: '100%',
    maxWidth: 150,
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
    },
  },
  squareLogo: {
    width: '100%',
    maxWidth: 140,
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 180,
    },
  },
  buttonItem: {
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2, 3),
    },
  },
}));

const StyledButton = withStyles((theme) => ({
  root: {
    maxWidth: 400,
    height: 43,
    '&:hover': {
      color: 'white',
    },
  },
  label: {
    '&:hover': {
      color: 'white',
    },
  },
}))(Button);

const Outro = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Title
        texts={['多数自治体などにご協力', 'いただいております！']}
        disableImage
      />

      <Grid
        container
        spacing={3}
        justify="center"
        alignItems="center"
        className={classes.containerLogos}
      >
        <Grid item xs={6} sm="auto">
          <img src={ShimaneImage} alt="shimane_logo" className={classes.logo} />
        </Grid>
        <Grid item xs={6} sm="auto">
          <img
            src={IrakakairouImage}
            alt="irakakairou_logo"
            className={classes.squareLogo}
          />
        </Grid>
        <Grid item xs={6} sm="auto">
          <img src={MasudaImage} alt="masuda_logo" className={classes.logo} />
        </Grid>
        <Grid item xs={6} sm="auto">
          <img
            src={YutalabImage}
            alt="yutalab_logo"
            className={classes.squareLogo}
          />
        </Grid>
        <Grid item xs={6} sm="auto">
          <img
            src={TottoriPrefectureImage}
            alt="tottori_prefecture_logo"
            className={classes.squareLogo}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Paper square elevation={0} className={classes.paper}>
          <Grid container className={classes.paperInner} alignItems="center">
            <Grid item md={8} xs={12}>
              <span>
                連携希望の自治体はまだまだ募集中です！人手不足等の困り事をキッカケに、一緒に関係人口を創出しましょう。ご希望の方はこちらのフォームからお気軽にお問い合わせください。
              </span>
            </Grid>
            <Grid item md={4} xs={12} className={classes.buttonItem}>
              <StyledButton
                fullWidth
                variant="contained"
                color="primary"
                href={CONTACT}
              >
                お問い合わせ
              </StyledButton>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </div>
  );
};

export default Outro;
